// extracted by mini-css-extract-plugin
export default {"headBorders":"CostEffectiveTable_headBorders__l9oIf","error":"CostEffectiveTable_error__V6HKI"};